import { sqliteTable, text, real, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// intercompany_links — การเชื่อมโยงระหว่างบริษัท (Intercompany Link)
// ============================================================================
export const intercompanyLinks = sqliteTable("accounting_intercompany_links", {
  id: text("id").primaryKey(), // ULID
  fromCompanyId: text("from_company_id").notNull(),
  toCompanyId: text("to_company_id").notNull(),
  fromAccountId: text("from_account_id").notNull(), // AR/AP account in source company
  toAccountId: text("to_account_id").notNull(), // AR/AP account in target company
  description: text("description"),
  isActive: integer("is_active").notNull().default(1),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  icFromToIdx: index("ic_from_to_idx").on(table.fromCompanyId, table.toCompanyId),
  icActiveIdx: index("ic_active_idx").on(table.isActive),
}));

// Type exports
export type IntercompanyLink = typeof intercompanyLinks.$inferSelect;
export type NewIntercompanyLink = typeof intercompanyLinks.$inferInsert;

// ============================================================================
// intercompany_transactions — รายการระหว่างบริษัท (Intercompany Transaction)
// ============================================================================
export const intercompanyTransactions = sqliteTable("accounting_intercompany_transactions", {
  id: text("id").primaryKey(), // ULID
  linkId: text("link_id").notNull(), // FK to intercompany_links
  sourceCompanyId: text("source_company_id").notNull(),
  targetCompanyId: text("target_company_id").notNull(),
  sourceDocType: text("source_doc_type").notNull(), // invoice, payment
  sourceDocId: text("source_doc_id").notNull(),
  targetDocType: text("target_doc_type"),
  targetDocId: text("target_doc_id"),
  amount: real("amount").notNull(),
  currencyCode: text("currency_code").default("THB"),
  status: text("status", {
    enum: ["pending", "matched", "eliminated"],
  }).notNull().default("pending"),
  eliminationJournalEntryId: text("elimination_je_id"), // JE for consolidated elimination
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  ictLinkIdx: index("ict_link_idx").on(table.linkId),
  ictSourceIdx: index("ict_source_idx").on(table.sourceCompanyId, table.sourceDocId),
  ictStatusIdx: index("ict_status_idx").on(table.status),
}));

// Type exports
export type IntercompanyTransaction = typeof intercompanyTransactions.$inferSelect;
export type NewIntercompanyTransaction = typeof intercompanyTransactions.$inferInsert;
